import { isObject, isString, type ExpandType } from "@mcwd/typescript-type-guards";



export type ParseErrorOptions = ExpandType<
  ({ defaultMessage: string; } |
  { callingLabel: string; }) &
  { cause?: unknown; doNotAddErrorToCauseForUnknownType?: boolean; }
>;
export function parseError (error: unknown, options: ParseErrorOptions)
{
  if (isObject(error) && error instanceof Error)
  {
    if ("cause" in options)
    {
      error.cause ??= options.cause;
    }
    return error;
  }
  let errOptions: { cause?: unknown; } | undefined = ("cause" in options) ? { cause: options.cause } : undefined;
  if (isString(error))
  {
    return new Error(error as string, errOptions);
  }
  const defaultMsg = ("defaultMessage" in options)
    ? options.defaultMessage
    : `Unknown error encountered in ${ options.callingLabel }`;
  if (options.doNotAddErrorToCauseForUnknownType !== true)
  {
    errOptions ??= {};
    if ("cause" in errOptions)
    {
      errOptions.cause = {
        details: errOptions.cause,
        error
      };
    }
    else
    {
      errOptions.cause ??= error;
    }
  }
  return new Error(defaultMsg, errOptions);
}
